// src/app/shared/services/event.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonEventService {
  private globalPhotoSubject = new Subject<string>();

  globalPhoto$ = this.globalPhotoSubject.asObservable();

  emitGlobalPhoto(url: string) {
    this.globalPhotoSubject.next(url);
  }
}